export default "__VITE_ASSET__vnFkQ0tS__"